/* eslint-disable no-loop-func */
import { Context } from '../types';

import { createDomElement } from './create-dom-element';
import { getManifest } from './get-manifest';
import { makeModuleVirtualModule } from './make-virtual-module';

/**
 * @description Get module data from manifest file
 * @param callback on load callback
 */
export async function getModuleData(
  this: Context,
  callback: () => void,
  testPath?: string,
): Promise<unknown> {
  const { host, element, virtual, name, mainContainerRef } = this;

  let hasCss = false;
  let hasJS = false;

  try {
    // Fetch manifest file
    const manifest: any = await getManifest(host, name, testPath);

    if (!JSON.stringify(manifest).includes('.css')) {
      hasCss = true;
    }

    if (this.beforeCallback) {
      this.beforeCallback(manifest);
    }

    // Process the received list of names
    for (const key in manifest.files) {
      const js = key.match(/\.js/);

      // If the file format is incorrect then skip
      if (!key.match(/\.js|\.css/) || key.includes('.map')) {
        continue;
      }

      const file = `${testPath ?? host}${manifest.files[key]}`;

      if (js) {
        if (virtual) {
          makeModuleVirtualModule(this, file, () => {
            hasJS = true;
            if (hasCss && hasJS) {
              callback();
            }
          });
          continue;
        }

        createDomElement('script', file, () => {
          hasJS = true;
          if (hasCss && hasJS) {
            callback();
          }
        }).add(mainContainerRef.current);
      } else {
        createDomElement('link', file, () => {
          hasCss = true;
          if (hasCss && hasJS) {
            callback();
          }
        }).add(element.parentNode);
      }
    }
    return null;
  } catch (e) {
    return e;
  }
}
